import { AuthenticationMethod, LinkStatus, DownloadedFrom, MpiFolder } from "./Enums";

export const InboxConstants = {
    DELETE_MESSAGE_CONFIRMATION: "Are you sure you want to delete this message?",
    DELETE_MESSAGES_CONFIRMATION: "Are you sure you want to delete selected message(s)?",
    CHANGE_EXPIRY_CONFIRMATION: "Are you sure you want to change expiry date?",
    MESSAGES_NOT_SELECTED: "Please select message!",
    FOLDER_NOT_SELECTED: "Please select folder!",
    FOLDER_ID: 1,
};

export const MessageListConstants = {
    REQUIRE_EXPIRY_DATE: "Please select expiry date!",
    NO_MESSAGE_TEXT: "No message(s) here.",
    AddNewFolder: {
        TITLE: "Add New Folder",
        FOLDER_NAME_CANNOT_BE_EMPTY_ERROR_MSG: "Please enter folder name.",
        FOLDER_NAME_ALREADY_EXISTS_ERROR_MSG: "Folder name already exists.",
    },
};

export const MessageConstants = {
    REQUIRE_EXPIRY_DATE: "Please select expiry date!",
    DELETE_MESSAGE_CONFIRMATION: "Are you sure you want to delete this message?",
    DELETE_MESSAGES_CONFIRMATION: "Are you sure you want to delete selected message(s)?",
    CHANGE_EXPIRY_CONFIRMATION: "Are you sure you want to change expiry date?",
    MESSAGES_NOT_SELECTED: "Please select message!",
    DELETE_MESSAGES_SUCCESS_MSG: "The selected message(s) were deleted successfully.",
    DELETE_MESSAGE_SUCCESS_MSG: "The message was deleted successfully.",
    NEWFOLDER_ADDED_SUCCESS_MSG: "Successfully added new folder.",
    NEWFOLDER_ADDED_FAILURE_MSG: "Failed to add new folder.",
};

export const InboxHeaderConstants = {
    REPLY: "Reply",
    REPLY_ALL: "Reply All",
    FORWARD: "Forward",
    DOWNLOAD: "Download All",
    DELETE: "Delete",
    PRINT: "Print",
    QUICK_REPLY: "Quick Reply",
};

export const MessageToolbarConstants = {
    TITLE_CHANGE_EXPIRY: "Change Expiry",
    TITLE_CHANGE_EXPIRY_RESTRICTED: "Change Expiry Restricted",
    TITLE_DELETE: "Delete",
    TITLE_OK: "Ok",
    TITLE_CANCEL: "Cancel",
    TITLE_MOVE_TO_FOLDER: "Move To",
    TITLE_NOT_SPAM: "Mark as Not a Spam",
    TITLE_MOVE_TO_INBOX: "Move To Inbox",
    TITLE_PRINT: "Print Message",
    TITLE_CANCEL_TRANSFER: "Cancel Transfer",
    TITLE_RESEND_ACCESS_LINK: "Resend Access Link",
    TITLE_RESEND_QA_AUTH_ANSWER: "Resend QA Authentication Answer",
    DELETE_MESSAGE: "Are you sure you want to delete the selected message(s)?",
    DELETE_SINGLE_MESSAGE: "Are you sure you want to delete the selected message?",
    CANCEL_TRANSFER_MESSAGE:
        "This action will delete all message copies and prevent the recipient from accessing the link or downloading the files. Are you sure you want to cancel transfer for the selected message(s)?",
    TITLE_DELETE_POPUP: "Delete Message",
    RESEND_AUTH_ANSWER_SUCCESS: "Authentication answer resent successfully",
    DESTINATION_FOLDER_EXPIRY_WARNING:
        "The retention period of the selected folder is less than the current folder. Moving to this folder will change retention period of this item(s).",
    TITLE_DOWNLOAD_ALL: "Download All",
    MESSAGE_MOVING_MULTIPLE_FOLDERS_WARNING: "Message can't be moved here as it contains subfolders",
    ELLIPSIS_TITLE: "More",
};

export const SentMessageConstants = {
    DELETE_MESSAGES_CONFIRMATION: `You are about to delete the selected message(s) which has not yet reached the expiration date. 
                                   Doing so will not remove the file or disable the link you sent. 
                                   To do that you must cancel the transfer, which will delete all copies of the message, 
                                   invalidate any download links and delete the files. <br/>
                                   Would you like to cancel the transfer or just the delete the message ?`,
    DELETE_MESSAGE_CONFIRMATION: `You are about to delete message which has not yet reached the expiration date. 
                                   Doing so will not remove the file or disable the link you sent. 
                                   To do that you must cancel the transfer, which will delete all copies of the message, 
                                   invalidate any download links and delete the files. <br/>
                                   Would you like to cancel the transfer or just the delete the message ?`,
    DELETE_MESSAGES_SUCCESS_MSG: "The selected message(s) were deleted successfully.",
    DELETE_MESSAGE_SUCCESS_MSG: "The message was deleted successfully.",
    CANCEL_MESSAGES_SUCCESS_MSG: "The selected message(s) were canceled successfully.",
    CANCEL_MESSAGE_SUCCESS_MSG: "The message was canceled successfully.",
    RESEND_ACCESS_LINK_SUCCESS_MSG: "Access link successfully resent",
    RESEND_QA_AUTH_ANSWER_SUCCESS_MSG: "Authentication answer successfully resent",
    RESEND_QA_AUTH_ANSWER_ERROR_MSG:
        "Messages with QA Authentication mode only can be selected for sending Authentication Answer.",
};

export const SentMessageToolbarConstants = {
    TITLE_CHANGE_EXPIRY: "Change Expiry",
    TITLE_DELETE: "Delete",
    TITLE_CHANGE_FOLDER: "Move To",
    TITLE_PRINT: "Print",
    TITLE_RESEND_ACCESS_LINK: "Resend Access Link",
    TITLE_RESEND_QA_AUTH_ANSWER: "Resend QA Authentication Answer",
};

export const SpamMessageConstants = {
    SUCCESS_MARK_MESSAGE_NOT_SPAM_MSG:
        "Selected messages are moved to Inbox successfully and the contact is white-listed",
    SUCCESS_MOVE_TO_INBOX_MSG: "Selected message(s) moved to Inbox successfully",
};

export const SpamMessageToolbarConstants = {
    TITLE_NOT_SPAM: "Not Spam",
    TITLE_MOVE_TO_INBOX: "Move To Inbox",
};

export const FolderConstants = {
    INBOX: 1,
    SENT: 2,
    SPAM: 3,
};

export const MoveToFolderConstants = {
    DESTINATION_FOLDER_EXPIRY_WARNING:
        "Destination folder's expiry less than the current folder's expiry. Do you want to continue?",
};

export const ArchiveMessageConstants = {
    TITLE_SELECT_FOLDER: "Select Folder",
    ChangeExpiry: {
        CONFIRMATION_MSG:
            "Changing the expiry of this folder will also change the expiry of all messages in this folder.",
        CONFIRMATION_TITLE: "Confirmation",
        BTN_OK: "OK",
        BTN_CANCEL: "Cancel",
        CHANGE_EXPIRY_SUCCESS_MSG:
            "The expiry of the selected folder and all messages in this folder has been changed successfully.",
    },
    AddNewFolder: {
        TITLE: "Add New Folder",
        FOLDER_NAME_CANNOT_BE_EMPTY_ERROR_MSG: "Folder Name cannot be empty.",
        FOLDER_NAME_ALREADY_EXISTS_ERROR_MSG: "Folder name already exists.",
    },
};

export const DEFAULT_PAGE_SIZE = 20;
export const UNLOCK_DEFAULT_PAGE_SIZE = 10;
export const MAX_ALLOWED_RECIPIENTS = 50;

export const FileConstants = {
    MaximumFileSize: "3221225472",
    MaximumTotalFileSize: 3221225472,
};
export const ThemeConstants = {
    ICON_DISABLE_COLOR: "#929292",
    SIDEMENU_ICON_COLOR: "#f7f6f6",
    SELECT_DROPDOWN_STYLES: {
        input: {
            border: "none",
        },
    },
    ICON_COLOR: "#05386B",
};
export const COMPOSE_HEADER_TEXT = "Add Recipients and Message";
export const DOCUMENT_HEADER_TEXT = "Upload Documents";
export const QNA_HEADER_TEXT = "Question & Answer Authentication";
export const SECURE_PDF_HEADER_TEXT = "Send Secure Pdf";

export const AuthenticationMethodsLabel = {
    CHANGE_AUTHENTICATION_METHOD_TOOLTIP: "Change Authentication Method",
    QUESTIONANSWER: "Question/Answer: Recipient must answer a question (Recommended)",
    LOGINPASSWORD: "Login: Recipient must enter username and password",
    ACCESSCODE: "Access Code",
    SECUREPDF:
        "Banks, Financial Institutions and Governmental Agencies: Where links do not get delivered through Corporate Firewalls.",
};

export const AuthenticationMethodsTitle = {
    QUESTIONANSWER: "Question and Answer",
    LOGINPASSWORD: "Login",
    ACCESSCODE: "Access Code",
    SENDSECUREPDF: "Secure PDF",
};

export const DropOffLinkTypeLabels = {
    COMPANY: "Company",
    PERSONAL: "Personal",
    NONE: "None",
};

export const getAuthMethodTitle = (authMethod: AuthenticationMethod) => {
    switch (authMethod) {
        case AuthenticationMethod.ACCESSCODE:
            return AuthenticationMethodsTitle.ACCESSCODE;
        case AuthenticationMethod.QUESTIONANSWER:
            return AuthenticationMethodsTitle.QUESTIONANSWER;
        case AuthenticationMethod.SENDSECUREPDF:
            return AuthenticationMethodsTitle.SENDSECUREPDF;
        // case AuthenticationMethod.LOGINPASSWORD:
        //     return AuthenticationMethodsTitle.LOGINPASSWORD;
        default:
            return "";
    }
};

export const AuthMethodDialogConstants = {
    METHOD_SELECTION_HEADER_TITLE: "Authentication Method",
    QNA_CARD_TITLE: "Question & Answer",
    ACCESS_CODE_CARD_TITLE: "Access Code",
    LOGIN_CARD_TITLE: "Login",
    SELECT_METHOD_HELP_TEXT: "Select which of the following mode you wish to proceed with:",
    QNA_HEADER_TITLE: "Question & Answer Authentication",
    QNA_METHOD_HELP_TEXT: "Assign the answers to your recipients by selecting the questions below",
};

export const QnAMethodDialogConstants = {
    ADD_NEW_QUESTION_ACCORDIAN_HEADER: "Add New Question",
    SET_QUESTION_ACCORDIAN_HEADER: "Set Questions & Answers",
    ADD_RECIPIENT_TITLE: "Add New Recipient",
};
export const ComposeValidations = {
    SELECT_AUTH_METHOD: "Please select authentication method!",
    RECIPIENT_VALID_EMAIL_REQUIRED: "Please enter valid email address!",
    SAVE_BEFORE_CONTINUE: "Please save recipient!",
    RECIPIENT_NAME_REQUIRED: "Please enter first name and last name!",
};

export const SecurityQuestion = {
    REQUIRE_VALIDATION_MESSAGE: "Please enter required field!",
    DUPLICATE_QUESTION_ERROR_MESSAGE: "This question already exists",
};

export const SecurityQuestionValidations = {
    REQUIRE_QUESTION_TITILE: "Question title required!",
    REQUIRE_QUESTION: "Question is required",
    QUESTION_ALREADY_EXISTS: "Question already exist, please change the question",
};

export const getWindowInnerHeight = () => {
    return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
};

export const ContactsConstants = {
    PASSWORD_RESEND_TOOLTIP: "Resend Password Link",
    SEND_INVITE_TOOLTIP: "Send Invite Link",
    HEADER_TITLE: "Contacts",
};

export const CompanySettingsMenuConstants = {
    SECURE_PDF_OPTIONS: "Secure PDF Options",
    ACCOUNT_PASSWORDS: "Account Passwords",
    CONTACT_OPTIONS: "Contact Options",
    LINK_AUTHENTICATION: "Link Authentication",
    MASTER_PDF_PASSWORDS: "Master PDF Passwords",
    SEND_OPTIONS: "Send Options",
    SENT_ITEMS_HISTORY: "Sent Items History",
    RECEIVED_ITEMS_HISTORY: "Received Items History",
    RETENTION_POLICY: "Retention Policy",
    COMPANY_LOGO: "Company Logo",
    PORTAL_CONFIGURATION: "Portal Configuration",
    DROPOFF_CONFIGURATION: "DropOff Configuration",
};

export const AccountPasswordsConstants = {
    EMPLOYEE_PASSWORDS_HEADER: "Employee Passwords",
    PASSWORDS_HEADER_INFO: "Character types to be included: Upper Case, Lower Case, Numbers and Special Characters",
    CONTACT_PASSWORDS_HEADER: "Contact Passwords",
    CONTACT_PASSWORDS_CHECKBOX_LABEL: "Allow non-confirming passwords for Contacts. (During Import/Password Creation)",
    PASSWORD_RETRIEVAL_HEADER: "Password Retrieval",
};

export const ContactOptionsConstants = {
    CONTACT_OPTIONS_HEADER: "Need Help Contact",
    CONTACT_POLICY_HEADER: "Contact Policies",
    DISPLAY_PHOTO_TOOL_TIP: "Navigate to the web portal to update/upload the desired photo for display.",
    DISPLAY_PHONE_NUMBER_LABEL: "Display phone number",
    DISPLAY_EMAIL_ADDRESS_LABEL: "Display email address",
    DISPLAY_PHOTO_LABEL: "Display photo",
    DISPLAY_FIRSTNAME_POLICY_LABEL: "Require employee to enter first and last name when adding contacts",
    DISPLAY_ALLOW_CONTACT_UPDATE_POLICY_LABEL: "Allow contacts to update their user profile",
};

export const SettingConstants = {
    HEADER_TITLE: "Settings",
    SETTINGS_UPDATE_SUCCESS_MESSAGE: "Your changes have been updated.",
};

export const MasterPdfPasswordsConstants = {
    SECURE_PDF_PASSWORDS_HEADER: "Secure PDF Passwords",
    MASTER_PDF_PASSWORD_HEADER: "Master PDF Password",
    MASTER_PDF_PASSWORD_HEADER_INFO: "Permission Password",
    RANDOMLY_GENERATED_PASSWORDS_CHECKBOK_LABEL: "Enable randomly generated passwords",
    MANUAL_PASSWORDS_CHECKBOK_LABEL: "Enable manual passwords",
    RANDOM_MANUAL_PASSWORDS_CHECKBOX_LABEL: "Send manually and randomly generated passwords in separate emails.",
    CURRENT_PASSWORD_LABEL: "Current Password:",
    ALLOW_EMPLOYEE_VIEW_PASSWORD_LABEL: "Allow employees to view",
    SETTINGS_UPDATE_SUCCESS_MESSAGE: "Settings are updated successfully",
    PASSWORD_SHOULD_NOT_EMPTY: "Master password cannot be empty",
};

export const SecurePdfSettingsConstants = {
    COVER_PAGE_MESSAGE_TITLE: "Cover Page Messages",
    USER_SIGNATURE_TITLE: "Secure PDF User Signature",
    ATTACHMENT_SETTINGS_TITLE: "PDF Attachment Settings",
};

export const CoverPageMessageValidations = {
    MESSAGE_TITLE_REQUIRED: "Message title required!",
    MESSAGE_REQUIRED: "Message required!",
};

export const UserSavedMessagesConstants = {
    COVER_PAGE_MESSAGE_TITLE: "Cover Page Messages",
};

export const LinkAuthenticationConstants = {
    AUTHENTICATION_QUESTION_TITLE: "Authentication Questions",
    EMPLOYEE_POLICY_TITLE: "Employee Policies",
    SECURITYQUESTION_DEFAULT_UNCHECK_WARNING:
        "Default question can't be unchecked. Please set a different question as default",
    SECURITYQUESTION_DEFAULT_DELETE_WARNING:
        "Default question can't be deleted. Please set a different question as default and delete",
};

export const SentItemsHistorySettingsConstants = {
    SENT_ITEMS_HISTORY_REPORT_HEADER: "Sent Items History Report",
    PURGE_HISTORY_REPORT_HEADER: "Purge History Report",
    ALLOW_VIEW_REPORT_CHECKBOK_LABEL: "View the Report",
    VIEW_TRANSFERS_USERS_CHECKBOK_LABEL: "View transfers of all users (Does not provide access to links)",
    RESEND_DOCUMENT_ACCESS_LINKS_CHECKBOK_LABEL: "Resend document access links (Also applies to My Portal Inbox)",
    VIEW_AUTHENTICATION_QA_CHECKBOK_LABEL: "View authentication question and answer",
    RESEND_QA_AUTH_ANSWER_CHECKBOK_LABEL: "Resend QA authentication answer (Also applies to My Portal Inbox)",
    PURGE_ITEMS_DATEPICKER_LABEL: "Purge Expired/Cancelled Items",
    PURGE_BTN_LABEL: "Purge",
    PURGE_SUCCESS_MSG: "Expired and cancelled sent item history purged successfully",
    PURGE_WARNING_MSG: `WARNING: You have selected to purge Expired or Cancelled Items from the report prior to {datePlaceholder}.
                        Expired or Cancelled Items prior to {datePlaceholder} will be permanently removed from the report and cannot be recovered.
                        Active Items will remain in the report. Are you sure you wish to make this change?`,
    SENT_ITEMS_HISTORY_SETTINGS_UPDATE_SUCCESS_MSG: "Settings are updated successfully",
};

export const ReceivedItemsHistorySettingsConstants = {
    RECEIVED_ITEMS_HISTORY_REPORT_HEADER: "Received Items History Report",
    PURGE_HISTORY_REPORT_HEADER: "Purge History Report",
    ALLOW_VIEW_REPORT_CHECKBOK_LABEL: "View the Report",
    VIEW_TRANSFERS_USERS_CHECKBOK_LABEL: "View transfers of all users (Does not provide access to links)",
    PURGE_ITEMS_DATEPICKER_LABEL: "Purge Expired/Cancelled Items",
    PURGE_BTN_LABEL: "Purge",
    PURGE_SUCCESS_MSG: "Expired and cancelled sent item history purged successfully",
    PURGE_WARNING_MSG: `WARNING: You have selected to purge Expired or Cancelled Items from the report prior to {datePlaceholder}.
                        Expired or Cancelled Items prior to {datePlaceholder} will be permanently removed from the report and cannot be recovered.
                        Active Items will remain in the report. Are you sure you wish to make this change?`,
    RECEIVED_ITEMS_HISTORY_SETTINGS_UPDATE_SUCCESS_MSG: "Settings are updated successfully",
    SETTINGS_UPDATE_SUCCESS_MESSAGE: "Settings are updated successfully",
};

export const SendOptionsConstants = {
    SENDOPTIONS_HEADER: "Send Method",
    LINKAUTH_HEADER: "Link Authentication",
    QA: "Question & Answer (Recommended)",
    QA_TOOLTIP: "Recipient must answer a question",
    LOGIN: "Login",
    LOGIN_TOOLTIP: "Recipient must enter username and password",
    ACCESSCODE: "Access Code",
    SECUREPDF: "Secure PDF Attachment",
    EMPLOYEEPOLICY_HEADER: "Employee Policies",
    CHANGE_SENDOPTION_LABEL: "Allow employees to change send option",
    CHANGE_DEFAULT_SENDOPTION_LABEL: "Allow employees to change their default option",
    SENDOPTION_DEFAULT_UNCHECK_WARNING: "Default method can't be unchecked. Please set a different method as default",
};

export const PortalConfigurationConstants = {
    SETTINGS_HEADER: "Portal Links",
    PORTAL_LOGIN_LINK: "Portal Login Link",
    COMPANY_DROPOFF_LINK: "Company DropOff Link",
    PERSONAL_DROPOFF_LINK: "Personal DropOff Link",
    COMPAY_SUB_DOMAIN: "Company Sub Domain",
    MAILBOX_DELEGATION_HEADER: "Mailbox Delegation",
    ENABLE_MAILBOX: "Enable other users to access my Mailbox",
    SETTINGS_UPDATE_SUCCESS_MESSAGE: "Your changes have been updated.",
    COMPAY_SUB_DOMAIN_PLACEHOLDER: "enter subdomain",
};

export const DropOffConfigurationConstants = {
    SETTINGS_HEADER: "Drop Off Configuration",
    ENABLE_PORTAL_LOGIN_LABEL: "Enable portal login link on Drop Off page",
    ALLOW_ADDRESS_BOOK_LOOKUP_LABEL: "Allow address book lookup",
    ALLOW_MULTIPLE_RECIPIENTS_LABEL: "Allow sender to include multiple recipients",
    ALLOW_PERSONAL_DROPOFF_LABEL: "Allow personal Drop Off links",
    DOWNLOAD_NOTIFICATION_LABEL: "Send download notification to the sender/client",
    ENABLE_SPAM_FILTERING_LABEL: "Enable spam filtering",
    BLACKLIST_ADDRESS_HEADER: "Blacklist address",
    WHITELIST_ADDRESS_HEADER: "Whitelist address",
    DROPOFF_RECIPIENTS_LABEL: "Manage Drop Off recipients:",
    FILE_TYPE_LABEL: "Restrict file types allowed in Drop Off:",
    ALSO_REQUIRE_LABEL: "In addition to first name, last name and email, also require:",
    SUBJECT_LABEL: "Subject",
    MESSAGE_LABEL: "Message",
    DEFAULT_DROPOFF_RECIPIENT: "Default Drop Off recipient:",
    SETTINGS_UPDATE_SUCCESS_MESSAGE: "Your changes have been updated.",
    ENTER_EXTENSION: "Enter extension",
};

export const LogoSettingsConstants = {
    SETTINGS_HEADER: "Company Logo",
    COMPANY_NAME_LABEL: "Use company name in text format:",
    COMPANY_LOGO_LABEL: "Use company logo",
    SAFESEND_LOGO_LABLE: "Use SafeSend logo",
    COPANY_NAME_WARNING: "Please specify company name",
    COMPANY_LOGO_INFO: "Visit the web portal to upload company logo",
    SETTINGS_UPDATE_SUCCESS_MESSAGE: "Settings are updated successfully",
    COMPANY_LOGO_DISPAY_AREA_HEADER: "Your company logo will display in the following areas",
    AREA_PORTAL_LOGIN_SCREEN: "Portal login screen",
    AREA_PORTAL_INBOX: "Portal inbox",
    AREA_CLIENT_DROPOFF: "Client DropOff",
    AREA_FILE_DOWNLOAD_PAGES: "File download pages",
    AREA_PDF_COVER_PAGE: "PDF cover page when sending secure PDF files",
    AREA_SECURE_PDF_FILES: "Secure PDF files",
    IMAGE_SIZE_WARNING: "Selected image exceeds the size limit of (width:300px Height:100px)",
    VALID_FILE_WARNING: "Please select a valid image",
    SELECT_LOGO_LABEL: "Select logo to use:",
};

export const RetentionPolicyConstants = {
    DEFAULT_RETENTION_PERIODS_HEADER: "Default Retention Periods",
    EMPLOYEE_POLICIES_HEADER: "Employee Policies",
    LOGIN_TRANSFERS_LABEL: "Login Transfers",
    QA_ACCESS_CODE_TRANSFERS_LABEL: "Q/A & Access Code Transfers",
    DROP_OFF_TRANSFERS_LABEL: "Dropoff Transfers",
    ALLOW_CHANGE_RETENTION_PERIOD_SEND_LINK_TRASFER:
        "Allow employees to change the retention period for a SendLink transfer",
    ALLOW_CHANGE_DEFAULT_SELECTION: "Allow employees to change their default selection",
    ATLEAST_ONE_RETENTION_PERIOD_SHOULD_ENABLE_WARNING_MSG: "Atleast one retention period should be enabled",
    ENABLE_RETENTION_PERIOD_WARNING_MSG: "Please enable $retentionPeriod retention period.",
    ENABLE_RETENTION_PERIOD_WARNING_MSG_PLACEHOLDER: "$retentionPeriod",
    ALLOW_CHANGE_DEFAULT_RETENTION_WARNING_MSG: "All users will be set to the current company retention period",
};

export const SecurePdfValidatation = {
    BLANK_PASSWORD_WARNING: "You have not entered a password. Do you want to send the file without encryption?",
    ATTACHMENT_NAME_REQUIRED: "Please enter attachment name!",
};

export const ForwardMessageValidation = {
    SELECT_RECIPIENT: "Please select recipient",
};

export const ReplyMessageValidation = {
    SELECT_RECIPIENT: "Please select recipient",
};

export const SentItemsHistoryConstants = {
    DIALOG_HEADER: "Sent Items History",
    COLUMN_SELECTION_HEADER: "Select Columns",
    REFRESH_TITLE: "Refresh",
    COLUMNS_TITLE: "Column Selection",
    DOWNLOAD_EXCEL_TITLE: "Download",
};

export const ReceivedItemsHistoryConstants = {
    DIALOG_HEADER: "Received Items History",
    COLUMN_SELECTION_HEADER: "Select Columns",
    REFRESH_TITLE: "Refresh",
    COLUMNS_TITLE: "Column Selection",
    DOWNLOAD_EXCEL_TITLE: "Download",
};
export const DragAndDropConstants = {
    UPLOAD_AREA: "Click or drag files here ",
};
export const ReportFilterConstants = {
    TOGGLE_TITLE: "Toggle",
    FILTER_TITLE: "Filter",
};

export function getLinkStatusDisplayName(status: LinkStatus): string {
    let value = "";
    switch (status) {
        case LinkStatus.Active:
            value = "Active";
            break;
        case LinkStatus.Cancelled:
            value = "Canceled";
            break;
        case LinkStatus.Expired:
            value = "Expired";
            break;
    }
    return value;
}

export const DownloadArchivedConstants = {
    SETTINGS_HEADER: "Download Archived Items",
    POLICY_LABEL:
        "As per our policy, the cancelled, deleted and expired messages prior to 1/1/2017 are archived. To access these messages (Before 1/1/2017), follow below steps",
    CLICK_REQUEST_DATA_LABEL: 'Click on "Request Data".', // eslint-disable-line
    CLICK_DOWNLOAD_LABEL: 'Click on "Download" option when enabled', // eslint-disable-line
    EXPIRED_MESSAGE_LABEL: "Only the expired and cancelled messages will be available for download.",
    SIH_LABEL: "Sent Item History",
    RIH_LABEL: "Received Item History",
    SIH_TITLE: "Click to request data for sent item history",
    RIH_TITLE: "Click to request data for received item history",
    REQUEST_DATA_BUTTON: "Request data",
};

export const SignatureConstants = {
    SETTINGS_HEADER: "My Cover Page Signatures",
    REQUIRE_SIGNATURE_TITILE: "Signature name required!",
    REQUIRE_SIGNATURE: "Signature required!",
    SIGNATURE_ALREADY_EXISTS: "Signature already exist, please change the signature.",
    DEFAULT_UNCHECK_WARNING: "Default signature can't be unchecked. Please set a different signature as default.",
    DELETED_SUCCESS: "Signature deleted successfully.",
    CREATED_SUCCESS: "New signature created successfully.",
    UPDATED_SUCCESS: "Signature updated successfully.",
};
export const ComposeMesssageConstants = {
    TO_LABEL: "To",
    TO_HELPTEXT: "The access link to files will only be sent to the recipients listed before 'Finish'.",
    TO_PLACEHOLDER: "Select Recipients",
    CC_LABEL: "Cc",
    CHECKBOX_LABEL: "Email me when files are downloaded",
    SUBJECT_LABEL: "Subject",
    SUBJECT_PLACEHOLDER: "Add subject",
    MESSAGE_LABEL: "Message",
    MESSAGE_PLACEHOLDER: "Enter message",
    FILES_DOWNLOAD_TEXT: "Retention Period",
    TAX_YEAR_TEXT: "Tax Year",
    EMAIL_TEMPLATE_NAME: "SendLinkTemplate.html",
    SUBJECT_MAX_LENGTH: 250,
    DROP_OFF_LINK_EMAIL_TEXT:
        "<br>DropOff Link : <a href=\"#COMPANYDROPOFFURL#\">\r\n                    Access link here\r\n                  </a>",
};
export const DownloadType = {
    single: "S",
    multiple: "M",
};

export const LocalStorageConstants = {
    USER_ID: "userId",
    IS_ADMIN: "isAdmin",
    otherUser: "mailboxUserData",
    USER_LOGGED_OUT: "userLoggedOut",
};

export const SessionStorageConstants = {
    IS_SIGN_IN_DIALOG: "isSignInDialog",
};

export function getDownloadedFrom(downloadType: string, folderId: MpiFolder): DownloadedFrom {
    let from: DownloadedFrom = DownloadedFrom.MPI_Download_Inbox_Single_File;
    switch (folderId) {
        case MpiFolder.Inbox:
            from =
                downloadType === DownloadType.single
                    ? DownloadedFrom.MPI_Download_Inbox_Single_File
                    : DownloadedFrom.MPI_Download_Inbox_Multiple_File;
            break;
        case MpiFolder.Sent:
            from =
                downloadType === DownloadType.single
                    ? DownloadedFrom.MPI_Download_SentItem_Single_File
                    : DownloadedFrom.MPI_Download_SentItem_Multiple_File;
            break;
        case MpiFolder.Archive:
            from =
                downloadType === DownloadType.single
                    ? DownloadedFrom.MPI_Download_Archive_Single_File
                    : DownloadedFrom.MPI_Download_Archive_Multiple_File;
            break;
    }
    return from;
}

export function getLocalDateTime(date?: Date) {
    const x = date ? date : new Date();
    const hoursDiff = x.getHours() - x.getTimezoneOffset() / 60;
    const minutesDiff = x.getMinutes() - (x.getTimezoneOffset() % 60);
    x.setHours(hoursDiff);
    x.setMinutes(minutesDiff);
    return new Date(x);
}

export const DATE_FORMAT = "MM/DD/YYYY";

export function getReplyBodyFormat() {
    return "<br />___________________________________________________________________ <br />";
}

export const RecipientQnAPlaceholder = {
    QUESTION_NAME: "Enter question name",
    QUESTION: "Write your question here",
    ANSWER: "Enter answer",
};

export const initialPagination = {
    pageSize: DEFAULT_PAGE_SIZE,
    currentPage: 1,
    totalRecords: 0,
};
export const initialDocumentPagination = {
    pageSize: DEFAULT_PAGE_SIZE,
    currentPage: 1,
};
export const MAX_SUBJECT_LENGTH = 250;
export const userSettingsConstant = {
    TITLE: "My Settings",
    DESCRIPTION: "You can set which users of the company can access your mailbox.",
    MAILBOX_DELEGATION_TITLE: "Mailbox Delegation",
    ENABLE_MAILBOX_DELEGATION: "Enable other users to access my Mailbox",
    DELEGATEE_LIST_TEXT: "Select User(s) to access your Mailbox",
    NO_DELEGATEE_TEXT: "No user found",
    NO_LOCATION_FOUND_TEXT: "No location found",
    DELEGATEE_SEARCH_PLACEHOLDER: "Search",
};

export const FolderToolbarConstants = {
    TITLE_MOVE_TO_FOLDER: "Move To",
    TITLE_CHANGE_RETENTION: "Change Retention Period",
    TITLE_DELETE: "Delete",
    TITLE_EDIT: "Edit",
    TITLE_CREATE_FOLDER: "Create Folder",
    TITLE_DELETE_FOLDERS: "Delete Folder(s)",
    TITLE_DELETE_FOLDER: "Delete Folder",
    DELETE_FOLDERS: "Are you sure you want to delete the selected folder(s)?",
    DELETE_FOLDER: "Are you sure you want to delete the selected folder?",
    DESTINATION_FOLDER_EXPIRY_WARNING:
        "The retention period of the selected folder is less than the current folder. Moving to this folder will change retention period of this item(s).",
    DESTINATION_FOLDER_EXPIRY_WARNING_FOR_MESSAGE:
        "The retention period of the selected folder is less than the current message(s). Moving to this folder will change the retention period of those message(s).",
    DESTINATION_FOLDER_GREATER_EXPIRY_WARNING_FOR_MESSAGE:
        "The retention period of the destination folder is greater than the expiry of the selected message(s). Choose another folder.",
    FOLDER_MOVING_TO_PARENT_FOLDER_WARNING: "Already in same location. Select different Path",
    TITLE_SHARE: "Share",
    TITLE_FOLDER_DROPOFF_DISABLED: "This action is restricted as the folder contains subfolders.",
    TITLE_FOLDER_DROPOFF: "Folder Link",
    REQUESTS_INCLUDE_ACTIVE: "Your selection includes active requests; only completed requests will be moved to the folder.",
    TITLE_DISABLE_FOLDER_NOTIFICATION: "Disable Notifications",
    TITLE_ENABLE_FOLDER_NOTIFICATION: "Enable Notifications",
    TITLE_FOLDER_NOTIFICATION: "Notification",
};

export const FolderDropOffModalConstants = {
    MODAL_TITLE: "Folder Link",
    MODEL_TITLE_COPY: "Copy",
};

export const ArchiveConstants = {
    TITLE_SELECT_FOLDER: "Select Folder",
    ChangeExpiry: {
        CONFIRMATION_MSG:
            "Changing the expiry of this folder will also change the expiry of all messages in this folder.",
        CONFIRMATION_TITLE: "Confirmation",
        BTN_OK: "OK",
        BTN_CANCEL: "Cancel",
        CHANGE_EXPIRY_SUCCESS_MSG:
            "The expiry of the selected folder and all messages in this folder has been changed successfully.",
    },
    NO_MESSAGES_OR_REQUESTS: "No message(s) or request(s) here.",
    AddNewFolder: {
        TITLE: "Add New Folder",
        FOLDER_NAME_CANNOT_BE_EMPTY_ERROR_MSG: "Please enter folder name.",
        FOLDER_NAME_CANNOT_HAVE_SPECIAL_CHARS_ERROR_MSG: 'Folder name cannot have special characters /\\:*?"<>|', // eslint-disable-line
        FOLDER_NAME_ALREADY_EXISTS_ERROR_MSG: "Folder name already exists.",
        SUB_FOLDER_MUST_HAVE_PARENT: "Please select location.",
        SUB_FOLDER_RETENTION_ERROR_MSG: "Please select retention period.",
        FOLDER_TYPE_SUBFOLDER: "Sub folder",
        FOLDER_TYPE_PRIMARY: "Primary",
        FOLDER_NAME_MAXLENGTH: 50,
        FOLDER_DESCRIPTION_MAXLENGTH: 100,
    },
    REFRESH_TITLE: "Refresh",
    ShareFolder: {
        NO_DATA_MESSAGE: "There are no items to show here.",
        SHARE_FOLDER_MODAL_TITLE: "Share Folder",
        SHARE_FOLDER_TEXT: "You are sharing <foldername> with:",
        SHARE_FOLDER_BUTTON_TEXT: "Share",
        PLACEHOLDER_SEARCH_TEXT: "Search",
    },
    PLACEHOLDER_SEARCH_TEXT: "Search in",
    PRIVATE_NAME: "Private",
    SHARED_NAME: "Shared",
    PRIVATE_INFO: "Accessible only to you.",
    SHARED_INFO: "Accessible to shared users.",
};

export const MyFilesConstants = {
    MY_FILES_NAME: "My Files",
    MY_FOLDER_NUMBER: "0",
    MAX_FILE_SIZE: 209715200,
    MAX_FILE_SIZE_EXCEEDED_MODAL_MESSAGE:"The total size of the files selected for download is greater than maximum limit for direct downloads. Please log in to the Exchange Web Application to download these files.",
    MAX_FILE_SIZE_EXCEEDED_MODAL_TITLE: "Download Size Limit Exceeded",
};

export const ValidationContants = {
    EmptyInputFieldWarning: "This field can't be empty",
    EmailAdrressWarning: "Please enter email address.",
    ValidEmailAddressWarning: "Please enter valid  email address.",
    DocumentCategoryWarning: "Please enter document category name",
};

export const RetentionPeriodModalConstants = {
    MODAL_TITLE: "Change Retention Period",
    PLACEHOLDER: "Select retention period",
};
export const CreateFolderModalConstants = {
    CREATE_FOLDER_MODAL_TITLE: "Create Folder",
    EDIT_FOLDER_MODAL_TITLE: "Edit Folder",
    FOLDER_NAME_LABEL: "Folder Name",
    FOLDER_NAME_PLACEHOLDER: "Enter folder name",
    FOLDER_RETENTION_PERIOD_LABEL: "Retention Period",
    FOLDER_RETENTION_PLACEHOLDER: "Select retention period",
    FOLDER_DESCRIPTION_LABEL: "Description",
    FOLDER_DESCRIPTION_PLACEHOLDER: "Add description",
};
export const ViewOthersInboxModalConstants = {
    MODAL_TITLE: "View Mailbox Of:",
    ICON_TITLE: "View Inbox",
};
export const BREADCRUMB_MAX_FOLDER_LEVEL = 5;
export const BREADCRUMB_MAX_FOLDER_LEVEL_ARCHIVE_TABLE = 3;
export const CompanyAuthQuestionsConstants = {
    TITLE_TEXT: "Authentication Questions",
    TITLE_HELPER_TEXT: "Manage security questions for Q&A authentication mode.",
    ALLOW_TO_ADD_OWN_QUESTIONS: "isUserAllowedToAddSecurityQuestion",
    ALLOW_TO_ADD_QUESTION_TOGGLE_TEXT: "Allow employees to add their own questions",
    ALLOW_TO_SET_DEFAULT_QUESTIONS: "isUserAllowedToChangeDefaultSecurityQuestion",
    ALLOW_TO_CHANGE_DEFAULT_QS_TEXT: "Allow employees to change their default questions",
    ADD_QUESTION_MODAL_TITLE: "Add New Question",
    ADD_QUESTION_INPUT_LABEL: "Add Question",
    ADD_QUESTION_INPUT_PLACEHOLDER: "Enter Question",
    ADD_QUESTION_TITLE_INPUT_LABEL: "Add Question Title",
    ADD_QUESTION_TITLE_INPUT_PLACEHOLDER: "Enter Question Title",
    ADD_QUESTION_DEFAULT_TOGGLE_LABEL: "Set as Default",
    EDIT_QUESTION_MODAL_TITLE: "Edit Question",
    EDIT_QUESTION_INPUT_LABEL: "Edit Question",
    EDIT_QUESTION_TITLE_INPUT_LABEL: "Edit Question Title",
    SET_DEFAULT_QUESTION_SUCCESS_MESSAGE: "Security Question updated as default question successfully.",
    DELETE_QUESTION_MODAL_TITLE: "Delete Question",
    DELETE_QUESTIONS_MODAL_TITLE: "Delete Question(s)",
    DELETE_QUESTION_MODAL_TEXT: "Do you want to delete the selected Question?",
    DELETE_QUESTIONS_MODAL_TEXT: "Do you want to delete the selected Question(s)?",
    INVALID_QUESTION_TEXT: "Question is required",
    INVALID_QUESTION_TITLE_TEXT: "Question Title is required",
    NO_MATCHING_RECORD: "No matching records found",
};
export const MessageOptionsConstants = {
    MESSAGE_OPTIONS_TITLE_TEXT: "Message Options",
    NOTIFICATIONS_HEADER: "Notification Settings",
    NOTIFICATION_HELPER_TEXT: "Manage your message and request level notifications.",
    MESSAGE_OPTIONS_HELPER_TEXT:
        "You can set your default authentication mode and retention period. It will reflect in composing, replying, or forwarding a message.",
    MY_SETTINGS_MESSAGE_OPTIONS_HELPER_TEXT: "Default Method",
    AUTHENTICATION_METHOD: "Authentication Method",
    AUTHENTICATION_METHOD_HELPER_TEXT: "Set the default authentication mode.",
    AUTHENTICATION_METHOD_BODY_HELPER_TEXT:
        "Choose which of the following modes should be made available to users, and set a default among them.",
    CHANGE_DEFAULT_METHOD_TEXT: "Allow employees to change their default method",
    CHANGE_AUTHENTICATION_METHOD_TEXT: "Allow employees to change Authentication Method",
    ALLOW_EMPLOYESS_TO_CHANGE_DEFAULT_METHOD: "allowEmployeesToChangeDefaultMethod",
    ALLOW_EMPLOYESS_TO_CHANGE_AUTH_METHOD: "allowEmployeesToChangeAuthMethod",
    CHANGE_CONTACT_SUPPORT_METHOD_WARNING_TEXT:
        "Turning this off will revert all user's support contact settings to the company's default. Do you want to continue?",
    CHANGE_AUTHENTICATION_METHOD_WARNING_TEXT: "Turning this off will revert all user's authentication methods to the company's default. Do you want to continue?",
    RETENTION_PERIOD: "Retention Period",
    RETENTION_PERIOD_HELPER_TEXT: "Set the default period for the below mode of transfers.",
    RETENTION_PERIOD_QNA: "Question and Answer",
    RETENTION_PERIOD_ACCESS_CODE: "Access Code",
    RETENTION_PERIOD_LOGIN: "Login",
    RETENTION_PERIOD_DROP_OFF: "Drop Off",
    RETENTION_PERIOD_FOLDERS: "Folders",
    DROP_OFF_LINKS: "Drop Off Links",
    DROP_OFF_LINKS_HELPER_TEXT: "Set which drop off link to be displayed in mail notification.",
    SELECT_DROP_OFF_LINK: "Select Drop Off link",
    NOTIFICATION_OPTION: "Notifications Option",
    NOTIFICATION_OPTION_HELPER_TEXT: "Manage notifications for Messages.",
    MESSAGE_ACCORDION_HEADER: "Message Notifications",
    MESSAGE_ACCORDION_HELPER_TEXT: "Manage notifications for Messages.",
    EXPIRATION: "Expiration",
    EXPIRATION_HELPER_TEXT: "Choose if users will receive a notification when file is about to expire.",
    CHANGE_NOTIFY_EXPIRY_TEXT: "Notify recipients when file(s) are about to expire",
    ALLOW_EMPLOYEES_TO_NOTIFY_EXPIRY_TEXT: "Allow employees to update their Expiry Notification setting",
    DOWNLOAD: "Download",
    DOWNLOAD_HELPER_TEXT: "Choose if users will receive a notification when a recipient downloads a file.",
    CHANGE_NOTIFY_DOWNLOAD_TEXT: "Notify when file(s) are downloaded",
    ALLOW_EMPLOYEES_TO_NOTIFY_DOWNLOAD_TEXT: "Allow employees to update their Download Notification setting",
    IS_EXPIRY_NOTIFICATION_ENABLE: "isExpiryNotificationEnable",
    IS_USER_ALLOWED_TO_CHANGE_EXPIRY_NOTIFICATION: "isUserAllowedToChangeExpiryNotification",
    IS_DOWNLOAD_NOTIFICATION_ENABLE: "isDownloadNotificationEnable",
    IS_USER_ALLOWED_TO_CHANGE_DOWNLOAD_NOTIFICATION: "isUserAllowedToChangeDownloadNotification",
    ALLOW_USER_TO_CHANGE_FOLDER_RETENTION_PERIOD_TEXT: "Allow employees to change the Folder retention period",
    ALLOW_USER_TO_CHANGE_MESSAGE_DR_RETENTION_PERIOD_TEXT: "Allow employees to change the Message and Request retention period",
    IS_USER_ALLOWED_TO_CHANGE_FOLDER_RETENTION_PERIOD: "isUserAllowedToChangeFolderRetentionPeriod",
    IS_USER_ALLOWED_TO_CHANGE_MESSAGE_DR_RETENTION_PERIOD: "isUserAllowedToChangeMessageAndDRRetentionPeriod",
    CHANGE_FOLDER_RETENTION_PERIOD_WARNING_TEXT: "Turning this off will revert all user's  folder retention period to the company's default. Do you want to continue?",
    CHANGE_MESSAGE_DR_RETENTION_PERIOD_WARNING_TEXT: "Turning this off will revert all user's  message and request retention period  to the company's default. Do you want to continue?",
    FILE_TYPE_SETTING_GENERAL_TITLE: "File Type Setting",
    FILE_TYPE_SETTING_GENERAL_INFO: " Set the file format(s) that must be allowed for the user during upload in Compose, Document Request and Folder Upload.",
    FILE_TYPE_SETTING_GENERAL_HELPER_TEXT: "Manage file types that must be allowed during upload. Add file extensions format as 'pdf','docx','xls' etc.",
};

export const RequestNotificationConstants = {
    REQUEST_COMPLETIONS: "Request Completions",
    REQUEST_REOPEN: "Re Opened Requests",
    REQUEST_NOTIFICATION_HELPER_TEXT: "Manage notifications for Document Requests.",
    REQUEST_NOTIFICATION_COMPLETION_HELPER_TEXT:
        "Choose if users will receive a notification when the request is complete.",
    REQUEST_NOTIFICATION_REOPEN_HELPER_TEXT:
        "Choose if users will receive a notification when the request is reopened.",
    REQUEST_NOTIFICATION_NOTIFY_CPA_WHEN_REQUEST_IS_COMPLETE: "Notify CPA when request(s) are completed",
    REQUEST_NOTIFICATION_ALLOW_EMPLOYEES_TO_UPDATE_COMPLETION_NOTIFICATION:
        "Allow employees to update their Completion Notification setting",
    REQUEST_NOTIFICATION_NOTIFY_TP_WHEN_REQUEST_IS_REOPEN: "Notify recipients when request(s) are reopened",
    REQUEST_NOTIFICATION_ALLOW_EMPLOYEES_TO_UPDATE_REOPEN_NOTIFICATION:
        "Allow employees to update their Re Opened Notification setting",
    IS_REQUEST_COMPLETION_NOTIFICATION_ENABLED: "isRequestCompletionNotificationEnabled",
    IS_REQUEST_COMPLETION_SETTING_ENABLED: "isDocumentRequestCompletionNotificationEnabled",
    IS_REQUEST_REOPENED_SETTING_ENABLED: "isDocumentRequestReopenNotificationEnabled",
    IS_REQUEST_REOPEN_NOTIFICATION_ENABLED: "isRequestReopenNotificationEnabled",
    IS_USER_ALLOWED_TO_CHANGE_REQUEST_COMPLETION_NOTIFICATION_ENABLED:
        "isUserAllowedToChangeRequestCompletionNotification",
    IS_USER_ALLOWED_TO_CHANGE_REQUEST_REOPEN_NOTIFICATION_ENABLED: "isUserAllowedToChangeRequestReopenNotification",
    REQUEST_NOTIFICATION_ACCORDIAN_HEADER: "Request Notifications",
    REQUEST_NOTIFICATION_ACCORDIAN_HELPER_TEXT: "Manage notifications for Document Requests.",
    REQUEST_COMPLETION_USER_SETTINGS: "Completion",
    REQUEST_REOPEN_USER_SETTINGS: "Re Open",
};

export const SupportContactsConstants = {
    SUPPORT_CONTACT_TITLE_TEXT: "Support Contact",
    SUPPORT_CONTACT_HELP_TEXT_LINE1: "Select which user should be the company support contact per office location.",
    SUPPORT_CONTACT_HELP_TEXT_LINE2: "This contact information will be displayed in the mails, TP, and Drop Off portals.",
    SUPPORT_CONTACT_DROP_DOWN_TEXT: "Support Contact",
    SUPPORT_CONTACT_DROP_DOWN_OFFICE_LOCATION_TEXT: "Office Location",
    SUPPORT_CONTACT_TOOGLE_SW_TEXT: "Display Phone Number",
    SUPPORT_CONTACT_TOOGLE_CHANGE_SUPPORT_CONTACT_TEXT: "Allow employees to change the Office Location and Support Contact",
    SUPPORT_CONTACT_HELP_TEXT_LINE3: "Select the default Support Contact based on the office location."
};

export const AuthMethodLabels = {
    ACCESSCODE: "Access Code",
    QUESTIONANSWER: "Question & Answer",
    LOGINPASSWORD: "Login",
};
export const MessageHistoryConstants = {
    MESSAGE_HISTORY_TITLE_TEXT: "Message History",
    MESSAGE_HISTORY_HELPER_TEXT:
        "Manage settings for the employees to access the sent and received items historical report.",
    MESSAGE_HISTORY_SENT_ITEMS_PAYLOAD: {
        IS_USER_ALLOWED_TO_VIEW_REPORTS: "isUserAllowedToViewReports",
        IS_USER_ALLOWED_TO_VIEW_TRANSFER_OF_ALL_USERS: "isUserAllowedToViewTransferOfAllUsers",
        IS_USER_ALLOWED_TO_RESEND_DOCUMENT_ACCESS_LINKS: "isUserAllowedToResendDocumentAccessLinks",
        IS_USER_ALLOWED_TO_VIEW_AUTHENTICATION_QNA: "isUserAllowedToViewAuthenticationQnA",
    },
    MESSAGE_HISTORY_RECEIVED_ITEMS_PAYLOAD: {
        IS_USER_ALLOWED_TO_VIEW_RECEIVED_MESSAGE_HISTORICAL_REPORT:
            "isUserAllowedToViewReceivedMessageHistoricalReport",
        IS_USER_ALLOWED_TO_VIEW_TRANSFER_OF_ALL_USERS_FOR_RECEIVED_ITEMS: "isUserAllowedToViewTransferOfAllUsers",
    },
    SENT_ITEMS_HISTORY: "Sent Items History",
    SENT_ITEMS_HISTORY_HELP_TEXT: "Manage access and settings for Sent Items History report.",
    VIEW_SENT_ITEMS: "View the Sent Items Historical report",
    VIEW_TRANSFER_OF_USERS: "View transfers of all users (does not provide access to links)",
    RESEND_DOCUMENT_ACCESS_LINKS: "Resend Document Access Links (Also applies to My Portal Inbox)",
    VIEW_QNA: "View Authentication Questions and Answers",
    RECEIVED_ITEMS_HISTORY: "Received Items History",
    RECEIVED_ITEMS_HISTORY_HELP_TEXT: "Manage access and settings for Received Items History report.",
    VIEW_RECEIVED_ITEMS: "View the Received Items Historical report",
};

export const RequestHistoryConstants = {
    REQUEST_HISTORY_HELP_TEXT: "Manage access and settings for Document Requests History report.",
    REQUEST_HISTORY_VIEW_DOCUMENT_REQUEST_HISTORY_TOGGLE_TEXT: "View the Document Requests History",
    REQUEST_HISTORY_VIEW_DR_SENT_BY_ALL_USERS_TEXT: "View Document Requests sent by all users",
    REQUEST_HISTORY_SETTINGS_PAYLOAD: {
        IS_USER_ALLOWED_TO_VIEW_REQUEST_HISTORICAL_REPORT: "isUserAllowedToViewDocumentRequestHistoricalReport",
        IS_USER_ALLOWED_TO_VIEW_REQUEST_HISTORY_REPORT_SENT_BY_ALL_USERS:
            "isUserAllowedToViewDocumentRequestSentByAllUsers",
    },
};

export const DropOffConfigConstants = {
    DROP_OFF_TITLE_TEXT: "Drop Off Configuration",
    DROP_OFF_HELPER_TEXT: "Manage access, recipients and file restrictions in this setting.",
    DROP_OFF_ALLOW_ADDRESS_BOOL_LOOKUP:
        "Allow Address Book Lookup (if disabled, users will have to enter valid email address)",
    DROP_OFF_ALLOW_PERSONAL_DROP_LINK: "Allow Personal Drop Off Links",
    DROP_OFF_ALLOW_MANAGE_LINK_IN_MAIL_NOTIFICATION: "Allow users to manage drop off links in mail notification",
    DROP_OFF_SEND_DOWNLOAD_NOTIFICATION: "Send download notification to the sender/client",
    DROP_OFF_ENABLE_SPAM_FILTERING:
        "Enable Spam Filtering (if enabled, incoming Email id will be validated with System contact list)",
    FILE_TYPE_RESTRICTION: "File Type Restriction",
    FILE_TYPE_RESTRICTION_INFO:
        "Set file format(s) that must be restricted for the user during upload in Drop Off portal",
    FILE_TYPE_RESTRICTION_HELPER_TEXT:
        "Manage file types that must be restricted during upload. Add file extensions format as 'pdf', 'docx', 'xls' etc.",
    IS_EMAIL_ADDRESS_LOOKUP_ALLOWED: "isEmailAddressLookupAllowed",
    IS_PERSONAL_DROP_OFF_LINK_TO_DISPLAY: "isPersonalDropOffLinkToDisplay",
    IS_DROP_OFF_LINK_TO_DISPLAY_IN_MAIL: "isUsersAllowedToManageDropOffLink",
    IS_DOWNLOAD_NOTIFICATION_TO_SEND: "isDownloadNotificationToSend",
    IS_SPAM_FILTERING_REQUIRED: "isSpamFilteringRequired",
    DROPDOWN_PLACEHOLDER: "Select the file extenstions...",
};

export const DropOffUsersConstants = {
    DROP_OFF_TITLE_TEXT: "Drop Off Users",
    DROP_OFF_HELPER_TEXT: "Manage access of drop off senders and recipients.",
    ACCORDIAN_TITLE_SENDERS: "Senders",
    SENDER_ACCORDIAN_HELP_TEXT:
        "Manage whitelisting and blacklisting of external users who use drop off for sharing files/messages. \nNote: All Clients in Client Management are already whitelisted and will not be listed here.",
    RECIPIENTS_ACCORDIAN_HELP_TEXT: "Manage Drop Off recipients.",
    ACCORDIAN_TITLE_RECIPIENTS: "Recipients",
    DEFAULT_BUTTON_LABEL: "Default",
    SET_DEFAULT_BUTTON_LABEL: "Set as Default",
    REMOVE_DEFAULT_BUTTON_LABEL: "Remove Default",
    ENABLE_DROP_OFF: "Enable",
    DISABLE_DROP_OFF: "Disable",
    SENDER_SEARCH_PLACEHOLDER: "Sender",
    RECIPIENT_SEARCH_PLACEHOLDER: "Recipient",
    NO_DATA_TEXT: "No matching records found",
    IS_DROPOFF_ENABLED: "isDropOffEnabled",
    IS_BLACKLISTED: "isBlacklisted",
    IS_DEFAULT: "isDefault",
    SENDER_WHITELIST_USERS_BUTTON: "Whitelist",
    SENDER_BLACKLIST_USERS_BUTTON: "Blacklist",
    USER_STATUS_TABLE_LABEL: "Status",
};
export const DropOffModalConstants = {
    DROP_OFF_SENDER__DELETE_MODAL_TITLE: "Delete Sender",
    DROP_OFF_SENDERS__DELETE_MODAL_TITLE: "Delete Sender(s)",
    DROP_OFF_SENDER_DELETE_MODAL_BODY: "Do you wish to delete the selected user?",
    DROP_OFF_SENDERS_DELETE_MODAL_BODY: "Do you wish to delete the selected user(s)?",
    DROP_OFF_ADD_MODAL_TITLE: "Add Sender",
    DROP_OFF_EDIT_MODAL_TITLE: "Edit Sender",
    ADD_SENDER_HELP_TEXT: "Mark as Blacklisted user",
    EDIT_SENDER_EMAIL_PLACEHOLDER: "Enter email address",
};

export const DropOffDropDownConstants = {
    SENDER_DROPDOWN_ALL_USERS: "All Users",
    SENDER_DROPDOWN_WHITELIST_USERS: "Whitelisted",
    SENDER_DROPDOWN_BLACKLIST_USERS: "Blacklisted",
    RECIPIENT_DROPDOWN_ENABLED_USERS: "Drop Off Enabled",
    RECIPIENT_DROPDOWN_DISABLED_USERS: "Drop Off Disabled",
};
export const UnlockLinkConstants = {
    UNLOCK_HEADER_TITLE_TEXT: "Unlock",
    UNLOCK_HEADER_TITLE: "Unlock Links",
    UNLOCK_BUTTON_TITLE: "Unlock",
    UNLOCK_HEADER_HELPER_TEXT: "Manage locked-out links for the users to access/upload their file(s).",
    UNLOCK_BUTTON_HOVER_TEXT: "Unlock link for the selected user(s).",
    NO_DATA_TEXT: "There are no items to show here",
};

export const OutOfOfficeLoadWarning =
    "Exchange Add-In can only run on outlook desktop application or outlook web.";

export const FeatureDisabledConstants = {
    DISABLED_TITLE: "Feature Disabled",
    DENIED_TITLE: "Access Denied",
    DISABLED_BY_TIER_DESCRIPTION:
        "This product is not supported on your current subscription tier," + "\n" + "please contact your ",
    DISABLED_BY_TIER_CUSTOMER_SUCCESS_REPRESENTATIVE: "Customer Success Representative ",
    DISABLED_BY_TIER_ENDING: "for access.",
    PRODUCT_DISABLED_IN_SETTINGS_DESCRIPTION:
        "We are sorry, but this feature is currently not available for your use." +
        "\n" +
        "Please contact your System Administrator for more information.",
    NO_PERMISSION_DESCRIPTION: "We are sorry, you do not have permission to access ",
    PRODUCT_NAME: "Exchange.",
    NO_PERMISSION_CONTACT_ADMINISTRATOR: "\n" + "Please contact your system administrator to update your user profile.",
};

export const AccessDeniedConstants = {
    ACCESS_DENIED_TITLE: "Access Denied",
    ACCESS_DENIED_DESCRIPTION: "Please consult your system" + "\n" + "administrator for assistance.",
    ACCESS_DENIED_BUTTON_TEXT: "Sign in as Different User",
};

export const LoadingScreenConstants = {
    LOADING: "Loading...",
};
export const ReportDownloadContansts = {
    REPORT_FILE_FORMAT: "csv",
    DEFAULT_FILE_NAME_SIH: "SafeSend_SIHreport_",
    DEFAULT_FILE_NAME_RIH: "SafeSend_RIHreport_",
    DATE_FORMAT_FILE_NAME: "YYYY_MM_DD",
    MULTIPLE_ATTACHMENT_FILE_NAME: "SafeSend_",
    MY_FILES_ZIP_NAME: "SafesendFiles_",
};

export const ReportConstants = {
    TIME_FORMAT: "MM/DD/YYYY hh:mm:ss a",
    FILE_POPOVER_TITLE: "Files",
    RECIPIENTS_POPOVER_TITLE: "Recipients",
    DOCUMENT_POPOVER_TITLE: "Documents",
    UPLOADED_FILES_POPOVER_TITLE: "Uploaded Files",
    ACTIVITY_LOG_POPOVER_TITLE: "Activity Log",
    SIH_TITLE: "Sent Items History",
    RIH_TITLE: "Received Items History",
    CONTEXT_MENU_RESEND_LINK: "Resend Link to",
    CONTEXT_MENU_CANCEL_TRANSFER: "Cancel Transfer",
    SHOW_SAVED_FILTER_TEXT: "Showing results for ",
    SHOW_CUSTOM_FILTER_TEXT: "Showing results based on filter",
    NO_DATA_MESSAGE: "There are no items to show here",
    SIH_METRICS_IDS: ["totalMessagesSent", "totalMessagesSentViaAccessCode", "totalMessagesSentViaQA"],
    SIH_METRICS_TITLES: ["Messages Sent", "Sent via Access Code", "Sent via Q&A"],
    RIH_METRICS_IDS: [
        "totalMessagesReceived",
        "totalMessagesReceivedViaDropOff",
        "totalMessagesReceivedViaFolderDropOff",
    ],
    RIH_METRICS_TITLES: ["Messages Received", "Received via Drop Off", "Received via Folder link"],
    DRH_METRICS_IDS: ["totalRequestSent", "totalFilesReceived"],
    DRH_METRICS_TITLES: ["Requests Sent", "Files Received"],
    DRH_TITLE: "Document Requests History",
};
export const ReportsFilterConstants = {
    FILTER_MODAL_TITLE: "Filters",
    FILTER_MODAL_CONFIRM_BUTTON_NAME: "Save",
    FILTER_MODAL_CANCEL_BUTTON_NAME: "Cancel",
    FILTER_MODAL_ADDITIONAL_BUTTON_NAME: "Apply",
    FILTER_DROPDOWN_PLACEHOLDER_TEXT: "Select",
    FILTER_DELETE_TITLE: "Delete Filter",
    FILTER_RESET_TITLE: "Reset Filter",
    FILTER_MODAL_SENDER_ACCORDION_TITLE: "Sender",
    FILTER_MODAL_RECIPIENT_ACCORDION_TITLE: "Recipient",
    FILTER_MODAL_SENT_DATE_ACCORDION_TITLE: "Sent Date",
    FILTER_MODAL_RECEIVED_DATE_ACCORDION_TITLE: "Received Date",
    FILTER_MODAL_LINK_STATUS_ACCORDION_TITLE: "Link Status",
    FILTER_MODAL_REQUEST_STATUS_ACCORDION_TITLE: "Request Status",
    FILTER_MODAL_TRANSFER_MODE_ACCORDION_TITLE: "Transfer Mode",
    FILTER_MODAL_ACTIVITY_LOG_ACCORDION_TITLE: "Activity Log",
    FILTER_MODAL_SENDER_SEARCH_PLACEHOLDER: "Search sender",
    FILTER_MODAL_SENDER_RECIPIENT_PLACEHOLDER: "Search recipient",
    FILTER_MODAL_SENDER_SEARCH_NOT_FOUND: "User not found",
    FILTER_MODAL_SEARCH_ALL: "All",
    FILTER_MODAL_SEARCH_ALL_TEXT: "All (select all search results)",
    SENT_DATE: "sentDate",
    ACTIVITY_LOG: "activityLog",
    FILTER_NAME_MAX_LENGTH: 50,
    SAVE_FILTER_MODAL_TITLE: "Save filter",
    DELETE_FILTER_MODAL_TITLE: "Delete filter",
    DELETE_FILTER_MODAL_TEXT: "Do you wish to delete the selected filter?",
    FILTER_LINK_STATUS: {
        ACTIVE: "Active",
        CANCELLED: "Cancelled",
        EXPIRED: "Expired",
    },
    FILTER_TRANSFER_MODES: {
        DROP_OFF: "Drop Off",
        PORTAL_QA: "Portal QA",
        PORTAL_ACCESS_CODE: "Portal Access Code",
        WEB_ADD_IN_QA: "Web Add-In QA",
        WEB_ADD_IN_ACCESS_CODE: "Web Add-In Access Code",
        Folder_DROP_OFF: "Folder Link",
    },
    FILTER_REQUEST_STATUS: {
        NONE: "None",
        PENDING_UPLOAD: "Pending Upload",
        PARTIALLY_UPLOADED: "Partially Uploaded",
        OVERDUE: "Overdue",
        COMPLETED: "Completed",
        Expired: "Expired",
        Cancelled: "Canceled",
    },
    DATE_TYPES: {
        ALL: "All",
        LAST_30_DAYS: "Last 30 days",
        LAST_12_MONTHS: "Last 12 months",
        CUSTOM: "Custom",
    },
    REPORT_MIN_DATE: "2010-08-03T05:40:46.171Z",
    REPORT_MIN_VALID_DATE: "2001-01-01T05:40:46.171Z",
    FILTER_APPLY_SUCCESS: "Filter applied successfully",
    REQUIRED_FIELDS_WARNING_MESSAGE: "Please enter all fields in the highlighted section(s).",
    INVALID_DATERANGE_FIELDS_WARNING_MESSAGE: "The entered date field is invalid.",
    DUPLICATE_FILTER_VALIDATION: "This filter name already exists. Try another one.",
};

export const DateFormatConstants = {
    DEFAULT_DATE_FORMAT: "MM/DD/YYYY",
    REPORTS_DATE_FORMAT: "MM/DD/YYYY hh:mm:ss a",
    LAST_LOGIN_DATE_FORMAT: "MM/DD/YYYY hh:mm:ss A",
    SAME_DAY_TIME_FORMAT: "HH:mm",
    CURRENT_WEEK_DATE_FORMAT: "ddd MM:DD",
    MESSAGE_DETAIL_DATE_FORMAT: "ddd MM-DD-YYYY HH:mm",
    DEFAULT_TIME_FORMAT: "HH:mm:ss A",
    DOCUMENT_EXPIRY_FORMAT: "MM-DD-YYYY",
    FILE_DETAILS_LAST_DOWNLOAD_DATE_FORMAT: "MM/DD/YYYY hh:mm:ss A",
};

export const UserAutoLogoutConstants = {
    PermissionChanged: "Permission Changed",
};

export const UserAutoLogoutMessageConstants = {
    PermissionChanged:
        "Your SafeSend permissions have been changed. You must login again for the changes to take effect.",
};

export const UserGroupConstants = {
    ADMIN: "Admin",
    STAFF: "Staff",
};

export const EmailTemplateConstants = {
    ONE_HUB_MESSAGE_HTML: `<div class="text-content" style="font-weight: 500; margin-top: 25px;">
        You also have the option to complete this task and
        manage additional tasks by accessing your Client
        Portal.
    </div>`,
    ONE_HUB_BUTTON_HTML: `<a class="innerBoxButton" style="width:151px; text-decoration-thickness: 1px; text-decoration-color: #0973BA;" href="#ONEHUBLINK#" target="_blank" rel="noopener noreferrer">
                                                        <span class="button-text" style="color: #0973BA;font-weight: 500; line-height: 160%; font-size: 20px;">
                                                            Access Client Portal
                                                        </span>
                                                    </a>`,
    VERTICAL_LINE_HTML: `<td style="width: 1px; background-color: #C4C6C8; height: 35px;"></td>`,
};

export const NewDRConstants = {
    MODAL_TITLE: "New Request",
    TO_LABEL: "To",
    TO_LABEL_INFO_TEXT: `
        Request link will be sent only to \nthe recipient added before "Finish"
    `,
    SUBJECT: "subject",
    AUTHENTICATION_METHOD: "authenticationMethod",
    EXPIRY_DAYS: "expiryDays",
    SUBJECT_LABEL: "Subject",
    SUBJECT_MAX_LENGTH: 255,
    TEMPLATE_LABEL: "Template",
    MESSAGE_LABEL: "Message",
    MESSAGE_LABEL_INFO_TEXT: "Please note your message content is subject to \nchange based on the template selected.",
    YEAR_LABEL: "Tax Year",
    DUE_DATE_LABEL: "Due Date",
    RETENTION_PERIOD_LABEL: "Retention Period",
    AUTHENTICATION_METHOD_LABEL: "Authentication Method",
    QUESTION_LABEL: "Question",
    QUESTION_DESCRIPTION_LABEL: "Question Description",
    ANSWER_LABEL: "Answer",
    FILE_REQUEST_LIST_LABEL: "Document List",
    OK_BUTTON_TEXT: "Send Request",
    CANCEL_BUTTON_TEXT: "Cancel",
    NOTIFY_ON_COMPLETION: "Notify on completion",
    YEAR_PLACEHOLDER_TEXT: "Year",
    ADD_FILES_TEXT: "Add Documents",
    SUBJECT_ERROR_TEXT: "Subject is required",
    RECIPIENT_ERROR_TEXT: "Recipient is required",
    MESSAGE_ERROR_TEXT: "Message is required",
    ANSWER_ERROR_TEXT: "Answer is required",
    QUESTION_ERROR_TEXT: "Question is required",
    CLOSE_CONFIRMATION_TITLE: "Exit Request",
    WARNING_TEXT: "Warning!",
    CLOSE_CONFIRMATION_TEXT_1: "Changes made to this request will be lost. ",
    CLOSE_CONFIRMATION_TEXT_2: "Are you sure you want to leave this section?",
    NO_TEMPLATE_TEXT: "(No template selected)",
    MAX_DUE_DATE: 7,
    NEXT: "Next",
    BACK: "Back",
    SEND_REQUEST: "Finish",
    MORE_INFORMATION: "More Information",
    SEND_DR_EMAIL_TEMPLATE_NAME: "SendDRWebAddInEmail.html",
    SEND_DR_EMAIL_DUE_DATE_SENTENCE: "We kindly request that you upload all the required files by null.",
    REQUEST_MORE_TEXT: "Request More",
    REQUEST_MORE_DISABLED_TITLE: "Reopen this request to get more documents.",
    DISABLED_PREVIEW_BUTTON: "Document preview is for PDF files only",
    DR_EMAIL_DUE_DATE_FORMAT: "MMMM DD, YYYY",
};

export const ComposeLandingPageConstants = {
    MESSAGE: "message",
    DR: "dr",
    PAGE_TITLE: "Question goes here",
    PAGE_DESCRIPTION: "Pick lorem ipsum dolor ests potus.",
    MESSAGE_CARD_TITLE: "Send Message",
    MESSAGE_CARD_DESCRIPTION: "Securely send messages and files.",
    DR_CARD_TITLE: "Request Documents",
    DR_CARD_DESCRIPTION: "Request and receive documents from list. ",
    CONTINUE: "Continue",
};
export const TemplateValidationConstants = {
    NAME_REQUIRED_TEXT: "Template name is required",
    DESCRIPTION_REQUIRED_TEXT: "Description is required",
    YEAR_REQUIRED_TEXT: "Year is required",
    DOCUMENT_NAME_TEXT: "Document Name is required",
};
export const TemplateListingConstants = {
    TITLE_TEXT: "Template Management",
    TITLE_HELPER_TEXT: "Save time on your request process by using or creating your own customized templates.",
    ADD_TEMPLATE_MODAL_TITLE: "New Template",
    EDIT_TEMPLATE_MODAL_TITLE: "Edit Template",
    REQUEST_MORE_MODAL_TITLE: "New Request",
    MODAL_NAME_INPUT_LABEL: "Template's Name",
    MODAL_NAME_INPUT_PLACEHOLDER: "Enter Template Name",
    MODAL_DESCRIPTION_INPUT_LABEL: "Description",
    MODAL_DESCRIPTION_INPUT_PLACEHOLDER: "Enter Description",
    MODAL_YEAR_INPUT_LABEL: "Tax Year",
    MODAL_YEAR_INPUT_PLACEHOLDER: "YYYY",
    MODAL_DUE_DATE_INPUT_LABEL: "Due Date",
    MODAL_FILES_REQUEST_INPUT_LABEL: "Document List",
    MODAL_FILE_NAME_PLACEHOLDER: "Enter Document Name",
    MODAL_FILE_DESCRIPTION_PLACEHOLDER: "Enter Document Description",
    INVALID_QUESTION_TITLE_TEXT: "Question Title is required",
    TEMPLATE_NAME_MAX_LENGTH: 200,
    TEMPLATE_DUPLICATE_NAME_CONDITION: 195,
    FILE_NAME_MAX_LENGTH: 50,
    FILE_DESCRIPTION_MAX_LENGTH: 100,
    NO_TABLE_DATA: "No template to display",
    NO_CATEGORY_TEXT: "(No category selected)",
};
export const TemplateModalConstants = {
    DELETE_TEMPLATE_MODAL_TITLE: "Delete Template",
    DELETE_TEMPLATES_MODAL_TITLE: "Delete Template(s)",
    DELETE_TEMPLATE_MODAL_BODY: "Do you wish to delete the selected template?",
    DELETE_TEMPLATES_MODAL_BODY: "Do you wish to delete the selected template(s)?",
    DELETE_TEMPLATE_SUCCESS: "Selected Template deleted successfully",
    DELETE_TEMPLATES_SUCCESS: "Selected Template(s) deleted successfully",
    DUPLICATE_TEMPLAE_SUCCESS: "Template duplicated successfully",
};

export const SortAndFilterConstants = {
    SORT_ORDER_ASC: "asc",
    SORT_ORDER_DESC: "desc",
    SORT_BY_TEXT: "Sort By",
    FILTER_BY_TEXT: "Filter By",
    ALPHABETICAL_ORDER_ASC: "A-Z",
    ALPHABETICAL_ORDER_DESC: "Z-A",
    NEWEST_FIRST_ORDER: "Newest First",
    OLDEST_FIRST_ORDER: "Oldest First",
    ALL_STATUSES_ORDER: "All Statuses",
    COMPLETED_ORDER: "Completed",
    PENDING_UPLOAD_ORDER: "Pending Upload",
    PARTIALLY_UPLOAD_ORDER: "Partially Uploaded",
    OVERDUE_ORDER: "Overdue",
};

export const DocumentRequestConstants = {
    REQUEST_DOCUMENT_TITLE_TEXT: "Request Documents",
    REQUEST_DOCUMENT_HELPER_TEXT: "Send, View and Manage document requests sent to the taxpayer.",
    TITLE_REQUEST_MORE_MODAL: "Request More",
    NO_DOCUMENT_REQUESTS: "No request(s) here.",
    PLACEHOLDER_SEARCH_TEXT: "Search by email",
    LINKED_RECIPIENTS_POPOVER_TITLE: "Linked Portal Emails",
};
export const DocumentToolbarConstants = {
    TITLE_DELETE: "Delete Request",
    DELETE_REQUEST: "Delete Request",
    DELETE_DOCUMENT: "Delete All File(s)",
    TITLE_SEND_REMINDER: "Send Reminder",
    TITLE_RESEND_ACCESS_LINK: "Resend Request",
    TITLE_CANCEL_REQUEST: "Cancel Request",
    TITLE_CHANGE_RETENTION: "Change Retention Period",
    TITLE_DOWNLOAD: "Download",
    TITLE_CHANGE_STATUS: "Change Status",
    CHANGE_STATUS_TO_COMPLETE_MESSAGE:
        "You are about to mark this request as complete. The taxpayer won't be able to submit or modify any more files after confirmation.\nContinue?",
    CHANGE_STATUS_TO_RE_OPEN_MESSAGE:
        "You are about to reopen this request. The taxpayer will be able to submit or modify files once reopened.\nContinue?",
    LISTING_DELETE_REQUEST: "Are you sure you want to delete the selected Request(s)?",
    DETAILED_DELETE_REQUEST: "Are you sure you want to delete the selected Request?",
    DETAILED_DELETE_DOCUMENT: "This action will delete all the files in this document. Do you wish to continue?",
    DETAILED_CANCEL_REQUEST_MESSAGE:
        "The link will no longer be accessible to taxpayers if this is canceled. Do you wish to proceed?",
    DETAILED_CANCEL_REQUEST_SUCCESS_MESSAGE: "Request cancelled Successfully",
    OPEN_STATUS: "Open",
    REOPEN_STATUS: "Re-Open",
    COMPLETED_STATUS: "Complete",
    SEND_DR_SUCCESS_MESSAGE: "Request sent successfully",
    CLIENT_NOTE_TITLE: "Client's Note",
    OPEN_LABEL: "Open",
    COMPLETED_LABEL: "Completed",
    DR_ZIP_FILE_NAME: "SafesendDR",
    REQUEST_DOCUMENT_PRINT_TITLE_TEXT: "REQUEST DOCUMENTS MESSAGE",
    DR_MOVING_MULTIPLE_FOLDERS_WARNING: "Request(s) can't be moved here as it contains subfolders",
    DR_EXPIRY_DOES_NOT_APPLY: "Expiry of request(s) will not be revised based on Folder's retention.",

};

export enum SortAndFilterIconType {
    Sort = 1,
    Filter = 2,
}
export const MessageTitleConstants = {
    TITLE_SENT: "SENT MESSAGE",
    TITLE_INBOX: "INBOX MESSAGE",
    TITLE_ARCHIVE: "FOLDER MESSAGE",
    TITLE_SPAM: "SPAM MESSAGE",
};
export const DocumentCategoryConstants = {
    DOCUMENT_CATEGORY_HELPER_TEXT: "Manage Document Category for the requests in this setting.",
    ADD_DOCUMENT_CATEGORY: " + Add Category",
    NO_DATA_MESSAGE: "There are no items to show here",
    EDIT_BUTTON_TEXT: "Edit",
    DELETE_BUTTON_TEXT: "Delete",
    CATEGORY_ALREADY_EXSITS: "This document category already exists.",
};

export const DocumentCategoryModalConstants = {
    ADD_CATEGORY_MODAL_TITLE: "Add Document Category",
    EDIT_CATEGORY_MODAL_TITLE: "Edit Document Category",
    DELETE_CATEGORY_MODAL_TITLE: "Delete Document Category",
    DELETE_CATEGORY_MODAL_TEXT: "Do you want to delete the selected Document Category?",
    DELETE_CATEGORIES_MODAL_TEXT: "Do you want to delete the selected Document Category(s)?",
};

export const RetentionPeriodConstants = {
    DAY: " Day",
    DAYS: " Days",
    _1YEAR: "1 Year",
    _3YEARS: "3 Years",
    _7YEARS: "7 Years",
    DAYS365: 365,
    DAYS1095: 1095,
    DAYS2555: 2555,
};

export const ThreadStyleClassNames = {
    THREAD_TITLE: "thread-item-selected",
    THREAD_MESSAGE: "thread-message-selected",
};

export const FileToolbarConstants = {
    VIEW_DETAILS: "View Details",
    DOWNLOAD: "Download",
};

export const FileViewDetailsModalConstants = {
    MODAL_TITLE: "View Details",
    FILE_NAME: "File Name",
    SUBJECT: "Subject",
    SIZE: "Size",
    LAST_DOWNLOAD: "Last Download",
    SENDER: "Sender",
    SENT_RECEIVED_DATE: "Sent/Received Date",
    DOCUMENT_NAME: "Document Name",
    DOCUMENT_CATEGORY: "Document Category",
    UPLOADED_BY: "Uploaded By",
    UPLOADED_DATE: "Uploaded Date",
    EXPIRE_DATE: "Expire Date",
};
